var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentPage',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"pl-2",staticStyle:{"font-size":"20px","font-weight":"bold"}},[_vm._v(" Badges & Bragging Rights ")])]},proxy:true}])},[_c('BadgesCard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }